/* eslint-disable ember/no-computed-properties-in-native-classes, ember/no-controller-access-in-routes, ember/no-runloop, warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';
import { alias } from '@ember/object/computed';
import { next } from '@ember/runloop';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import Jurisdiction from '@linc-technologies/linced-common/enums/jurisdiction';
import PersonType from '@linc-technologies/linced-common/enums/person-type';
import TransactionType from '@linc-technologies/linced-common/enums/transaction-type';
import { optionAlias } from '@linc-technologies/linced-common/utils/options';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class TransactionsRoute extends Route {
  queryParams = {
    from: {
      refreshModel: true,
    },
    to: {
      refreshModel: true,
    },
    transactionType: {
      refreshModel: true,
    },
    cancelled: {
      refreshModel: true,
    },
  };

  // Services
  @service
  options;

  @service
  session;

  @service
  store;

  @alias('session.school.jurisdiction')
  jurisdiction;

  @optionAlias('finance:nswDoe:piaLedgerItemId')
  piaLedgerItemId;

  model(params) {
    let baseFilters = {
      dateFrom: params.from,
      dateTo: params.to,
      include: 'lineItems,ledgerItems,ledgers,accounts',
    };
    if (params.cancelled) {
      baseFilters.isCancelled = true;
    } else if (params.transactionType !== '0') {
      // Only single-type reports should filter based on cancellation status.
      baseFilters.isNotCancelled = true;
    }
    let transactionFilters = {
      type: params.transactionType,
    };
    Object.assign(transactionFilters, baseFilters);
    let requests = {
      transactions: this.store.query('finance/transaction', transactionFilters),
      students: this.store.query('person', {
        type: PersonType.LEARNER,
        includeFormer: true,
      }),
    };
    if (
      this.jurisdiction === Jurisdiction.AU_NSW &&
      !isEmpty(this.piaLedgerItemId)
    ) {
      // Fetch the PIA ledger item for NSW schools (if set).
      requests.piaLedgerItem = this.store.findRecord(
        'finance/ledger-item',
        this.piaLedgerItemId,
      );
    }
    // Retrieve Apportionment records too if the user selected Payment as the type.
    if (parseInt(params.transactionType, 10) === TransactionType.PAYMENT) {
      let apportionmentFilters = {
        type: TransactionType.APPORTIONMENT,
      };
      Object.assign(apportionmentFilters, baseFilters);
      requests.apportionments = this.store.query(
        'finance/transaction',
        apportionmentFilters,
      );
    }
    return hash(requests);
  }

  activate() {
    super.activate(...arguments);
    next(this, function () {
      this.controllerFor('application').set('isWideList', true);
    });
  }

  deactivate() {
    super.deactivate(...arguments);
    next(this, function () {
      this.controllerFor('application').set('isWideList', false);
    });
  }

  resetController(controller) {
    controller.reset();
  }
}
